module.exports = __webpack_public_path__ + "static/media/bennett_mosca.3a78a2d9.gif";